import { Chip } from '@festo-ui/react';
import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';

import './ChipContainer.scss';

export interface Filter {
  key: string;
  label: string;
  filters?: Filter[];
}

interface ChipContainerProps {
  filterList: Filter[];
}

const ChipContainer: FC<ChipContainerProps> = ({ filterList }) => {
  const [hasFilters, setHasFilters] = useState(filterList.length > 0);
  const t = useTranslation();

  useEffect(() => {
    setHasFilters(filterList.length > 0);
  }, [filterList]);

  return (
    <div className="fwe-chip-container fwe-chip-container__mobile fwe-chip-container-lg fwe-mb-5">
      {hasFilters && <div className="hide-block hide-transition--left" />}
      {filterList.map((filter, index) => (
        <div className={`chip-unit ${index === 0 ? 'ml' : ''}`} key={`${filter.key} ${filter.label}`}>
          <p className="label">{t(filter.key)}</p>
          <div className="chip--text-container">
            <Chip selected>
              <p>{t(filter.label)}</p>
            </Chip>
            <div className="chip-multivalue">
              {filter.filters &&
                filter.filters?.map((subFilter) => (
                  <span key={`${subFilter.key} ${subFilter.label}`}>
                    <Chip selected>
                      <p>{t(subFilter.label)} </p>
                    </Chip>
                  </span>
                ))}
            </div>
          </div>
        </div>
      ))}
      {hasFilters && <div className="hide-block hide-transition--right" />}
    </div>
  );
};

export default ChipContainer;
